import Cookies from "js-cookie";
import * as types from "../mutation-types";

// state
export const state = {
  autoplay: Cookies.get("autoplay") || true,
  sidebarColor: Cookies.get("sidebarColor"),
  themeColor: Cookies.get("themeColor"),
};

// mutations
export const mutations = {
  [types.UPDATE_SETTINGS](state, { autoplay, sidebarColor, themeColor }) {
    state.autoplay = autoplay;
    state.sidebarColor = sidebarColor;
    state.themeColor = themeColor;
    Cookies.set("autoplay", autoplay, { expires: 365 });
    Cookies.set("sidebarColor", sidebarColor, { expires: 365 });
    Cookies.set("themeColor", themeColor, { expires: 365 });
  },

  [types.FETCH_SETTINGS](state) {
    // state.autoplay = Cookies.get('autoplay') || true
    // state.sidebarColor = Cookies.get('sidebarColor')
    // state.themeColor = Cookies.get('themeColor')
    // this.$vuetify.dark = (state.sidebarColor === 'dark')
    // this.$vuetify.theme.primary = this.state.themeColor
    // console.log(this.$vuetify)
  },
};

// actions
export const actions = {
  updateSettings({ commit, dispatch }, payload) {
    commit(types.UPDATE_SETTINGS, payload);
  },
  loadSettings({ commit, dispatch }) {
    commit(types.FETCH_SETTINGS);
  },
};
